import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Button, Stack, Typography } from '@mui/material';
import QRCodeData from '../ui/grcode/qrCodeData';
import MuiLink from '@mui/material/Link';
import { Link } from 'react-router-dom';
import PoweredBy from '../ui/poweredBy';

const PrintGreensQRCodes = () => {
  const event = useSelector((state) => state.event.event);

  const handlePrint = () => {
    window.print();
  };

  return (
    <>
      <style>
        {`
          @media print {
            /* Hide everything by default */
            body * {
              visibility: hidden;
            }
            
            /* Show only the printable content */
            .printable-qr-codes,
            .printable-qr-codes * {
              visibility: visible;
            }
            
            /* Position the printable content at the top */
            .printable-qr-codes {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
            }
            
            /* Remove margins and adjust layout for print */
            .qr-code-container {
              display: flex !important;
              flex-wrap: wrap !important;
              justify-content: flex-start !important;
              gap: 20px !important;
              margin: 0 !important;
              padding: 20px !important;
            }
            
            .qr-code-item {
              break-inside: avoid;
              margin: 10px !important;
              page-break-inside: avoid;
              border: 2px solid black !important;
            }
            
            /* Ensure text is black when printing */
            .qr-code-item * {
              color: black !important;
              -webkit-print-color-adjust: exact !important;
              color-adjust: exact !important;
            }
            
            /* Hide non-essential elements */
            .no-print {
              display: none !important;
            }
          }
        `}
      </style>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
        className="no-print">
        <Stack>
          <Typography variant="h4" gutterBottom>
            Greens QR Codes
          </Typography>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
          <Button variant="outlined" component={Link} to={`/events/${event.id}`}>
            Back to Event
          </Button>
          <Button variant="contained" color="primary" onClick={handlePrint}>
            Print Codes
          </Button>
        </Stack>
      </Box>

      <Box
        display="flex"
        flexWrap="wrap"
        justifyContent="center"
        alignItems="center"
        gap={2}
        className="printable-qr-codes qr-code-container">
        {event.greens.map((venue, index) => (
          <Box display={'flex'} flexWrap="wrap" key={index}>
            <Typography
              variant="h5"
              gutterBottom
              width={'100%'}
              textAlign={'center'}
              mt={2}
              mb={1}
              className="no-print">
              {venue.name}
            </Typography>

            {venue.greens.map((green, index) => (
              <Box display={'flex'} flexWrap="wrap" key={index}>
                {green.rinks &&
                  green.rinks.length > 0 &&
                  green.rinks.map(
                    (rink) =>
                      rink.active && (
                        <Box
                          display={'flex'}
                          sx={{ border: '2px solid', borderColor: 'primary.main' }}
                          m={1}
                          p={2}
                          justifyContent="center"
                          alignItems="center"
                          flexDirection="column"
                          key={`${green.name}-${rink.rink}`}
                          className="qr-code-item">
                          <Typography variant="h4" gutterBottom>
                            {`${green.name}${rink.rink}`}
                          </Typography>
                          <Box>
                            <QRCodeData
                              value={`${window.location.origin}/public/scoring/${event.id}/${venue.id}/${green.name}${rink.rink}`}
                              style={{ width: '130px', height: '130px' }}
                            />
                          </Box>
                          <MuiLink
                            component={Link}
                            to={`/public/scoring/${event.id}/${venue.id}/${green.name}${rink.rink}`}
                            target="_blank"
                            className="no-print">
                            <Typography variant="body1" color="primary">
                              View Game
                            </Typography>
                          </MuiLink>

                          <PoweredBy overrideMode={'light'} />
                          <Typography
                            variant="caption"
                            color="textSecondary"
                            fontSize={'8px'}
                            component={'span'}>
                            {venue.name}
                          </Typography>
                        </Box>
                      )
                  )}
              </Box>
            ))}
          </Box>
        ))}
      </Box>
    </>
  );
};

export default PrintGreensQRCodes;
